import { Component, OnInit, Input, Inject, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CompaniesService } from '../../services/companies.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientNotesModalComponent } from '../client-notes-modal/client-notes-modal.component';
import { InstanceTypes } from '../../models/instance-types';
import { AclService } from '../../services/acl.service';
import { PayrollManagement } from '../../tools/payroll-management';
import { RouteParamsService } from '../../services/route-params.service';
import { SwipeclockService } from '../../services/swipeclock.service';
import { ClientSetup } from '../../models/client';
import { Select, Store } from '@ngxs/store';
import { ClientSelectionState } from '../../state/ClientSelectionState/ClientSelection.state';
import { forkJoin, Observable, Subject } from 'rxjs';
import { first, map, take, takeUntil } from 'rxjs/operators';
import { ClientFeatureWhitelistService } from '../../services/client-feature-whitelist.service';
import { ClientTimeOffRequestService } from '../../services/time-off-request.service';
import { EmployerSelectionState } from '../../state/EmployerSelectionState/EmployerSelection.state';

@Component({
  selector: 'lib-client-sub-nav',
  templateUrl: './client-sub-nav.component.html',
  styleUrls: ['./client-sub-nav.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(50, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        // :leave is alias to '* => void'
        animate(50, style({ opacity: 0 }))
      ])
    ])
  ],
  standalone: false
})
export class ClientSubNavComponent implements OnInit {
  @Input() activeTab = 'Home';

  render: boolean = true;
  constructor() {}

  ngOnInit() {
    this.render = true;
  }
}
